'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * Use `Paragraph` to display text with paragraph text styles.
 * Renders a native `p` element.
 *
 * @example
 * <Paragraph data-size='lg'>Paragraph</Paragraph>
 */
const Paragraph = forwardRef(function Paragraph({ className, asChild, variant = 'default', ...rest }, ref) {
    const Component = asChild ? Slot : 'p';
    return (jsx(Component, { ref: ref, className: cl(`ds-paragraph`, className), "data-variant": variant, ...rest }));
});

export { Paragraph };
